import React from 'react'
import { TExtraField, TExtraFieldValue } from '../../../../models/ExtraField'
import { Form, Switch } from 'antd'

interface Props {
  idx: number
  fieldConfig: TExtraField
  fieldValue: TExtraFieldValue
}

export const ExtraFieldFormValuesCheckbox = ({ idx, fieldConfig, fieldValue }: Props) => (
  <Form.Item
    key={fieldConfig.id}
    label={fieldConfig.name}
    name={['fields', idx, 'value']}
    valuePropName={'checked'}
    extra={fieldConfig.extraId}
  >
    <Switch />
  </Form.Item>
)
